import * as React from 'react';

import './SlideMenu.scss';

interface ISlideMenuState {
  show: boolean;
  style: object;
}

interface ISlideMenuProps {
  children: any;
  mounted: boolean;
  goBackTitle: string;
  level: number;
  handleCloseMenu: () => void;
}

class SlideMenu extends React.Component<ISlideMenuProps, ISlideMenuState> {
  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      style: {
        transform: 'translateX(-100%)',
        transition: 'transform 200ms ease-in'
      }
    };
  }

  public componentWillReceiveProps(newProps: any) {
    if (!newProps.mounted) {
      return this.unMountStyle();
    }
    this.setState({
      show: true
    });
    setTimeout(this.mountStyle, 10);
  }

  public unMountStyle = () => {
    this.setState({
      style: {
        transform: 'translateX(-100%)',
        transition: 'transform 200ms ease-in',
        zIndex: 999999
      }
    });
  };

  public mountStyle = () => {
    this.setState({
      style: {
        transform: 'translateX(0)',
        transition: 'transform 200ms ease-out',
        zIndex: this.props.level
      }
    });
  };

  public transitionEnd = () => {
    if (!this.props.mounted) {
      this.setState({
        show: false
      });
    }
  };

  public render() {
    return (
      this.state.show && (
        <div
          style={this.state.style}
          onTransitionEnd={this.transitionEnd}
          className="rp-slide-menu roboto"
        >
          <div
            onClick={e => this.props.handleCloseMenu()}
            className="rp-slide-menu--go-back-title"
          >
            <span className="rpds-keyboard-backspace go-back-arrow-icon" />
            {this.props.goBackTitle}
          </div>
          {this.props.children}
        </div>
      )
    );
  }
}

export default SlideMenu;
